import React, { useState, useEffect } from 'react';
import i18next from 'i18next';

import { AssetTypesService } from '../../services';
import { OpSenseToastContainer, toast } from "../Toast";
import { PageTitle } from '../PageTitle';

const AssetTypeView = ({ match }) => {
  const [assetType, setAssetType] = useState(null);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setHasError(false);
    AssetTypesService.get(match.params.assetTypeId).then((response) => {
      setAssetType(response.assetType);
    }).catch((error) => {
      console.error(error);
      setHasError(true);
      toast.error(i18next.t("messages.could-not-load-asset-type-view"));
    });
  }, [match]);

  return assetType || hasError ? (
      <div>
          <OpSenseToastContainer />

          <div className="row">
              <PageTitle title={i18next.t("pages.asset-types.view-asset-type")} backLinkWithParams={{ link: { pathname: "/admin/asset-types" } }} />
          </div>

          {!hasError && <div className="login-form tag-form op-content-box">
              <div className="row" style={{marginBottom: 20}}>
                  <div className="col-sm-6">
                      <label>{i18next.t("form-labels.name")}</label>
                      <span>{assetType.name}</span>
                  </div>
                  <div className="col-sm-6">
                      <label>{i18next.t("form-labels.requires-floorplan")}</label>
                      <span>{assetType.requiresFloorplan ? i18next.t("yes") : i18next.t("no")}</span>
                  </div>
              </div>

              <div className="row" style={{marginBottom: 20}}>
                  <div className="col-sm-6">
                      <label>{i18next.t("pages.asset-types.default-tags")}</label>
                      <span>{assetType.defaultTags.filter(tag => tag.tagType.token != 'area').map((tag) => tag.name).join(",")}</span>
                  </div>
                  <div className="col-sm-6">
                      <label>{i18next.t("pages.asset-types.default-area")}</label>
                      <span>{assetType.defaultTags.filter(tag => tag.tagType.token == 'area').map((tag) => tag.name).join(",")}</span>
                  </div>
              </div>

              <div className="row" style={{marginBottom: 20}}>
                  <div className="col-sm-12">
                      <label>{i18next.t("pages.asset-types.allowed-measures")}</label>
                      <table className='table'>
                        <thead>
                          <tr>
                            <th style={{width: '60%'}}>{i18next.t('pages.asset-types.name')}</th>
                            <th style={{width: '30%'}}>{i18next.t('pages.asset-types.measure')}</th>
                          </tr>
                        </thead>
                        <tbody>
                        {
                          assetType.measures.length == 0 ?
                          <tr>
                              <td colSpan={2} style={{textAlign: 'center'}}>
                                {i18next.t('pages.asset-types.no-measures')}
                              </td>
                          </tr>
                          :
                          assetType.measures.sort((a, b) => a.displayOrder - b.displayOrder).map(measure => 
                            <tr key={measure.id}>
                              <td>{measure.name}</td> 
                              <td>{measure.deviceDataClassification.name}</td>
                            </tr>
                          )
                        }
                        </tbody>
                      </table>
                  </div>
              </div>

              <div className="row" style={{marginBottom: 20}}>
                  <div className="col-sm-12">
                      <label>{i18next.t("pages.asset-types.metadata-types")}</label>
                      <table className='table'>
                        <thead>
                          <tr>
                            <th style={{width: '60%'}}>{i18next.t('pages.asset-types.name')}</th>
                            <th style={{width: '30%'}}>{i18next.t('pages.asset-types.value-type')}</th>
                          </tr>
                        </thead>
                        <tbody>
                        {
                          assetType.assetTypeMetadataTypes.length == 0 ?
                          <tr>
                              <td colSpan={2} style={{textAlign: 'center'}}>
                                {i18next.t('pages.asset-types.no-metadata-types')}
                              </td>
                          </tr>
                          :
                          assetType.assetTypeMetadataTypes.map(metadataType => 
                            <tr key={metadataType.id}>
                              <td>{metadataType.name}</td> 
                              <td>{metadataType.stringValueFlag ? i18next.t('pages.asset-types.string') : i18next.t('pages.asset-types.numeric')}</td>
                            </tr>
                          )
                        }
                        </tbody>
                      </table>
                  </div>
              </div>
          </div>}
      </div>
  ) : (
      <div className="loader">{i18next.t("loading")}</div>
  );
}

export default AssetTypeView;
